import { EstimateurEtape } from '@components/estimateur-etape/models';
import { estimatorOptionMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const estimateurEtapeMock: Block<EstimateurEtape> = {
  type: 'estimateur-etape',
  data: {
    title: {
      text: `J'estime le budget de ma cuisine en  [[quelques clics]]`,
      as: 'h1',
    },
    step1: {
      pictos: [
        {
          svg: '/assets/tmp/store.svg',
        },
        {
          svg: '/assets/tmp/store.svg',
        },
      ],
      style: {
        title: `Je choisis mon style`,
        options: [
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
        ],
      },
      implantation: {
        title: `Je choisis mon implantation`,
        options: [estimatorOptionMock(), estimatorOptionMock(), estimatorOptionMock(), estimatorOptionMock()],
      },
      size: {
        title: `Je choisis la taille de ma cuisine`,
        options: [estimatorOptionMock(false, true), estimatorOptionMock(false, true), estimatorOptionMock(false, true)],
      },
      workPlan: {
        title: `Je choisis mon plan de travail`,
        options: [
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
          estimatorOptionMock(true),
        ],
      },
    },
    step2: {
      pictos: [
        {
          svg: '/assets/tmp/store.svg',
        },
        {
          svg: '/assets/tmp/store.svg',
        },
      ],
      sinkType: {
        title: `Je choisis mon évier`,
        options: [estimatorOptionMock(true), estimatorOptionMock(true), estimatorOptionMock(true)],
      },
      householdAppliance: {
        title: `Je choisis mon électro ménager`,
        options: [
          estimatorOptionMock(),
          estimatorOptionMock(),
          estimatorOptionMock(),
          estimatorOptionMock(),
          estimatorOptionMock(),
          estimatorOptionMock(),
          estimatorOptionMock(),
        ],
      },
    },
    step3: {
      pictos: [
        {
          svg: '/assets/tmp/store.svg',
        },
        {
          svg: '/assets/tmp/store.svg',
        },
      ],
      installation: {
        title: `Je choisis ma formule de pose`,
        options: [estimatorOptionMock(true), estimatorOptionMock(true)],
      },
    },
    cta: {
      label: `Estimer mon budget`,
      url: '/mock-estimateur-budget-recap',
    },
    gtmConfigViewStep2: {
      event: 'view_page_estimation_2',
      group: 'estimation',
      description: 'etape 2 estimation',
      context: 'chargement deuxieme etape tunnel estimation',
    },
    gtmConfigViewStep3: {
      event: 'view_page_estimation_3',
      group: 'estimation',
      description: 'etape 3 estimation',
      context: 'chargement troisieme etape tunnel estimation',
    },
    gtmConfigViewStep3Btn: {
      event: 'click_cta_estimation_next',
      group: 'estimation',
      description: 'etape 2 estimation',
      context: 'click bouton continuer',
    },
  },
};
